"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocalLink = exports.isBlankTarget = void 0;
function isBlankTarget(target) {
    return target === '_blank';
}
exports.isBlankTarget = isBlankTarget;
function isLocalLink(href) {
    return (typeof href === 'string' &&
        !href.startsWith('https://') &&
        !href.startsWith('http://') &&
        !href.startsWith('//'));
}
exports.isLocalLink = isLocalLink;
